export default __webpack_public_path__ + "dfba6246b284681e4a6eda8e396eba33.png";